import React from 'react';
import './submitted.css'; 

const Submitted = () => {
  return (
    <div className="submitted-container">
      <h1>Your form is submitted...</h1>
      <p>Our volunteer will get in touch with you.....</p>
    </div>
  );
};

export default Submitted;
